import { BoxProgramInformation } from "@/modules/boxProgrammation/components/boxProgramInformation"
import { cn } from "@/modules/lib/utils"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { HustleupSmallIcon } from "@images/svgIcons/hustleUpSmallIcon"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { useParams } from "react-router"

export function BoxPlanningHeaderRightView({
  className,
  ...props
}: {
  className?: string
} & React.ComponentProps<"div">) {
  const { boxProgramId } = useParams()

  return (
    <>
      {boxProgramId ? (
        <ErrorBoundary resetKeys={[boxProgramId]} fallback={<HustleupSmallIconComponent />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxProgramInformation boxProgramId={boxProgramId} />
          </Suspense>
        </ErrorBoundary>
      ) : (
        <HustleupSmallIconComponent className={className} {...props} />
      )}
    </>
  )
}

type HustleupSmallIconComponentProps = {
  className?: string
} & React.ComponentProps<"div">
function HustleupSmallIconComponent({ className, ...props }: HustleupSmallIconComponentProps) {
  return (
    <div
      className={cn(
        "relative mb-5 flex h-50 max-h-50 justify-evenly overflow-hidden rounded-4xl bg-linear-to-r from-secondary-100 to-secondary-200 p-4.5 text-textDefault-body md:p-2 xl:p-4",
        className,
      )}
      {...props}
    >
      <HustleupSmallIcon className="absolute -top-[10%] right-0 h-[120%] opacity-22" />
    </div>
  )
}
